import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import MeetKalinda from "@/pages/MeetKalinda";
import Issues from "@/pages/Issues";
import News from "@/pages/News";
import Volunteer from "@/pages/Volunteer";
import Donate from "@/pages/Donate";
import VotingInfo from "@/pages/VotingInfo";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/meet-kalinda" element={<MeetKalinda />} />
          <Route path="/issues" element={<Issues />} />
          <Route path="/news" element={<News />} />
          <Route path="/volunteer" element={<Volunteer />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/voting-info" element={<VotingInfo />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
